import { TRootState, TDealsState } from '../../types'
import { createSelector } from '@reduxjs/toolkit'
import { dealsAdapter } from './adapter'

const selectState = (state: TRootState): TDealsState => state.deals

const adapterSelectors = dealsAdapter.getSelectors(selectState)

const fetchStatus = createSelector(
    selectState,
    (state) => ({
        isFetching: state.isFetching,
        error: state.fetchError,
    })
)

export const selectors = {
    ...adapterSelectors,
    fetchStatus
}